import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c78430c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c78430c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c78430c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c78430c')) {
      api.createRecord('3c78430c', component.options)
    } else {
      api.reload('3c78430c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c78430c&scoped=true", function () {
      api.rerender('3c78430c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/homeInsureManage/index.vue"
export default component.exports